import angular from 'angular'

import './sticky.less'

/**
 * Make the element stick to the top of the window.
 * @param {any} $window The angular Window wrapper.
 * @returns {any} The directive.
 */
export function StickyDirective($window) {
    'ngInject'
    const directive = {
        restrict: "A",
        link: link
    }
    return directive;

    function link(scope, element, attrs) {
        const $win = angular.element($window);

        if (scope._stickyElements === undefined) {
            scope._stickyElements = [];

            $win.bind("scroll.sticky", function (e) {
                const pos = $win.scrollTop();
                for (let i = 0; i < scope._stickyElements.length; i++) {

                    const item = scope._stickyElements[i];

                    if (!item.isStuck && pos > item.start) {
                        item.element.addClass("stuck");
                        item.isStuck = true;

                        if (item.placeholder) {
                            item.placeholder = angular.element("<div></div>")
                                .css({ height: item.element.outerHeight() + "px" })
                                .insertBefore(item.element);
                        }
                    } else if (item.isStuck && pos < item.start) {
                        item.element.removeClass("stuck");
                        item.isStuck = false;

                        if (item.placeholder) {
                            item.placeholder.remove();
                            item.placeholder = true;
                        }
                    }
                }
            });

            const recheckPositions = function () {
                for (let i = 0; i < scope._stickyElements.length; i++) {
                    const item = scope._stickyElements[i];
                    if (!item.isStuck) {
                        item.start = item.element.offset().top;
                    } else if (item.placeholder) {
                        item.start = item.placeholder.offset().top;
                    }
                }
            };
            $win.bind("load", recheckPositions);
            $win.bind("resize", recheckPositions);
        }

        const item = {
            element: element,
            isStuck: false,
            placeholder: attrs.usePlaceholder !== undefined,
            start: element.offset().top
        };

        scope._stickyElements.push(item);
    }
}
